

































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import http from "@/axios/http-common";

@Component
export default class ReturObatFromResepDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop() register!: string;

  loading = false;
  resepItems: any[] = [];
  selectedItems: any[] = [];

  tableHeaders = [
    { text: "Nama Obat", value: "nama_obat" },
    { text: "Kekuatan", value: "kekuatan", width: "90px" },
    { text: "Satuan", value: "satuan", width: "70px" },
    { text: "Jml Resep", value: "jumlah", width: "80px" },
    { text: "Kategori", value: "kategori", width: "120px" },
    { text: "Jml Retur", value: "jumlah_retur", width: "90px" },
    { text: "Kondisi", value: "kondisi", width: "150px" },
  ];

  kondisiOptions = [
    { value: "utuh", text: "Utuh" },
    { value: "terbuka_layak", text: "Terbuka (Layak)" },
    { value: "terbuka_tidak_layak", text: "Terbuka (Tidak Layak)" },
    { value: "expired", text: "Expired" },
    { value: "rusak", text: "Rusak" },
  ];

  kategoriOptions = [
    { value: "obat", text: "Obat" },
    { value: "cairan", text: "Cairan" },
    { value: "alkes", text: "Alkes" },
    { value: "narkotika", text: "Narkotika" },
    { value: "nutrisi", text: "Nutrisi" },
  ];

  get dialogVisible() {
    return this.value;
  }

  set dialogVisible(val: boolean) {
    this.$emit("input", val);
  }

  @Watch("value")
  async onDialogOpen(val: boolean) {
    if (val) {
      this.selectedItems = [];
      await this.fetchResepItems();
    }
  }

  async fetchResepItems() {
    this.loading = true;
    try {
      const resp = await http.getData(`/register/${this.register}/resep-obat-text`);
      const resepList = resp.data?.data || [];
      const items: any[] = [];

      for (const resep of resepList) {
        // Obat non-racikan + obat penyusun racikan.
        const racikanItems = (resep.resep_racikan || []).reduce(
          (acc: any[], rc: any) => acc.concat(rc.items || []),
          []
        );

        for (const ri of [...(resep.items || []), ...racikanItems]) {
          items.push({
            id: ri.id,
            nama_obat: ri.obat_nama || "Unknown",
            kekuatan: ri.ap_dosis || "",
            satuan: ri.qty_unit || "unit",
            jumlah: ri.qty || 0,
            obat_id: ri.obat_id,
            harga: ri.harga || null,
            _jumlah_retur: ri.qty || 1,
            _kondisi: "utuh",
            _kategori: "obat",
          });
        }
      }

      this.resepItems = items;
    } catch {
      this.resepItems = [];
    }
    this.loading = false;
  }

  close() {
    this.dialogVisible = false;
  }

  save() {
    const items = this.selectedItems.map((item: any) => ({
      resep_obat_item_id: item.id,
      jumlah_retur: item._jumlah_retur,
      kondisi: item._kondisi,
      kategori: item._kategori,
    }));

    this.$emit("save", items);
  }
}
